import {Field, ErrorMessage} from 'formik';
import TextError from './TextError';

function Switch(props: any) {
  const {label, name, options, ...rest} = props;
  return (
    <div className='form-check form-switch mb-7 pt-16 pe-6' style={{transform: 'translateX(1rem)'}}>
      <Field name={name} {...rest}>
        {({field}: {field: any}) => {
          return (
            <>
              <input
                className='form-check-input mb-3 mb-lg-0'
                role='switch'
                type='checkbox'
                id={name}
                {...field}
                value={true}
                checked={field.value === true}
              />
              <label className='form-check-label fw-bold fs-6' htmlFor={name}>
                {label}
              </label>
            </>
          );
        }}
      </Field>
      <ErrorMessage name={name} component={TextError} />
    </div>
  );
}

export default Switch;
